export default __webpack_public_path__ + "static/media/Memorabilia2.6376f7dc.png";